function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import dc from 'dc';
import * as d3 from 'd3';
import { BaseMixin } from '../Mixins/BaseMixin';
import { AVIFactTileSmall } from '../../Layout/AVIFactTileSmall/AVIFactTileSmall';
import { withAVIDashboardContext } from '../../Context/AVIDashboard/AVIDashboard';
import '../Charts.scss';
export var NumberDisplay = /*#__PURE__*/function (_Component) {
  _inheritsLoose(NumberDisplay, _Component);

  function NumberDisplay(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.chartRef = React.createRef();
    _this.chart = null;
    return _this;
  }

  var _proto = NumberDisplay.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.chart = dc.numberDisplay(this.chartRef.current);
    BaseMixin(this.chart, this.props);
    var _this$props = this.props,
        valueAccessor = _this$props.valueAccessor,
        formatNumber = _this$props.formatNumber,
        html = _this$props.html;
    this.chart.valueAccessor(valueAccessor).formatNumber(formatNumber).html(html).render();

    if (this.props.register) {
      this.props.register(this.chart, this.props.name, false);
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.group != this.props.group) {
      this.chart.group(this.props.group).redraw();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.props.unregister) {
      this.props.unregister(this.chart, this.props.name);
    }
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        chartTitle = _this$props2.chartTitle,
        toolsComponent = _this$props2.toolsComponent;
    return /*#__PURE__*/React.createElement(AVIFactTileSmall, {
      title: chartTitle,
      toolsComponent: toolsComponent
    }, /*#__PURE__*/React.createElement("div", {
      className: 'avi-chart chart number-display',
      ref: this.chartRef
    }));
  };

  return NumberDisplay;
}(Component);

_defineProperty(NumberDisplay, "defaultProps", {
  valueAccessor: function valueAccessor(d) {
    return d;
  },
  formatNumber: d3.format(',.0f'),
  html: {
    one: '',
    some: '',
    none: ''
  }
});

NumberDisplay.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Set or get the value accessor function. The value accessor function is used to retrieve the value from the crossfilter group. Group values are used differently in different charts, for example values correspond to slice sizes in a pie chart and y axis positions in a grid coordinate chart. */
  valueAccessor: PropTypes.func,

  /** Get or set a function to format the value for the display. */
  formatNumber: PropTypes.func,

  /** Gets or sets an optional object specifying HTML templates to use depending on the number displayed. The text `%number` will be replaced with the current value.
   *
   * `one`: HTML template to use if the number is 1
   *
   * `zero`: HTML template to use if the number is 0
   *
   * `some`: HTML template to use otherwise */
  html: PropTypes.object,

  /** Title */
  chartTitle: PropTypes.string,

  /** Key name of the chart used by `AVIDashboardContext` in terms of the mapping name and id in the `register` method */
  name: PropTypes.string
} : {};
export default withAVIDashboardContext(NumberDisplay);